<template>
  <div>
    <div class="search-box btn3" :class="{ close: !searchMore }">
      <div class="input-item">
        <span class="label">协议名称</span>
        <Input v-model="searchObj.name" placeholder="请输入" clearable />
      </div>
      <div class="input-item" v-if="levelCode == '10001'">
        <span class="label">签约机构</span>
        <Select v-model="searchObj.signOrgId" clearable filterable transfer>
          <Option :value="item.id" v-for="(item, index) in signOrgTreeList" :key="index">{{ item.name }}</Option>
        </Select>
      </div>
      <div class="input-item">
        <span class="label">签约通道</span>
        <Select v-model="searchObj.insuranceSupplierId" clearable filterable transfer>
          <Option :value="item.id" v-for="(item, index) in insuranceCompanyList" :key="index">{{ item.name }}</Option>
        </Select>
      </div>

      <div class="input-item">
        <span class="label">状态</span>
        <Select v-model="searchObj.status" clearable transfer>
          <Option value="0">待生效</Option>
          <Option value="1">生效中</Option>
          <Option value="2">已过期</Option>
          <Option value="3">已终止</Option>
        </Select>
      </div>

      <div class="input-item">
        <span class="label">协议编号</span>
        <Input v-model="searchObj.covenantNo" placeholder="请输入" clearable />
      </div>

      <div class="input-item">
        <span class="label">协议类型</span>
        <Select v-model="searchObj.covenantLevel" clearable transfer>
          <Option value="1">主协议</Option>
          <Option value="2">补充协议</Option>
        </Select>
      </div>

      <div class="input-item">
        <span class="label">通道性质</span>
        <Select v-model="searchObj.insuranceSupplierType" clearable transfer>
          <Option value="1">总公司</Option>
          <Option value="2">分公司</Option>
        </Select>
      </div>

      <div class="input-item">
        <span class="label">签约产品</span>
        <Select v-model="searchObj.productCode" :filterable="true" clearable transfer>
          <Option :value="item.productCode" v-for="item in products" :key="item.id">{{ item.productName }}</Option>
        </Select>
      </div>

      <div class="input-item">
        <span class="label" style="min-width: 85px">产品所属保司</span>
        <Select v-model="searchObj.companyCode" clearable filterable transfer>
          <Option :value="item.code" v-for="(item, index) in productCompany" :key="index">{{ item.name }}</Option>
        </Select>
      </div>

      <div class="input-item">
        <span class="label">到期日期</span>
        <DatePicker
          type="daterange"
          split-panels
          separator="至"
          :transfer="true"
          placement="bottom"
          format="yyyy-MM-dd"
          placeholder="选择日期"
          :value="searchObj.date"
          @on-change="searchObj.date = $event"
        ></DatePicker>
      </div>

      <div class="btn-item">
        <Button type="primary" @click="search">查询</Button>
        <Button type="primary" ghost @click="reset">重置</Button>
        <Button type="primary" ghost v-if="searchMore" @click="searchMore = false"
          >收起
          <Icon type="ios-arrow-up" />
        </Button>
        <Button type="primary" ghost v-else @click="searchMore = true"
          >展开
          <Icon type="ios-arrow-down" />
        </Button>
      </div>
    </div>
    <div class="tools-box right">
      <Button type="warning" class="add-btn" @click="addAgreement">新增</Button>
      <Button type="primary" @click="importData">导入</Button>
    </div>

    <loading :isShow="$root.$children[0].isShowLoading" />
    <div class="table-box setTable">
      <Table :columns="columns" :data="tableData" row-key="id">
        <template slot-scope="{ row }" slot="name">
          <span
            v-if="row.fileJson && row.fileJson != '&quot;&quot;' && row.fileJson != '[]'"
            class="fileName"
            @click="$refs.previewModal.open(JSON.parse(row.fileJson))"
            >{{ row.name }}</span
          >
          <span v-else-if="!row.name">-</span>
          <span v-else>{{ row.name }}</span>
        </template>
        <template slot-scope="{ row }" slot="status">
          <span v-show="row.status == '0'">待生效</span>
          <span v-show="row.status == '1'">生效中</span>
          <span v-show="row.status == '2'">已过期</span>
          <span v-show="row.status == '3'">已终止</span>
        </template>

        <template slot-scope="{ row }" slot="action">
          <a class="table-btn" @click="edit(row)" v-show="$units.pointAction('pro_6_1')">编辑</a>
          <a class="table-btn" @click="signProduct(row)" v-show="$units.pointAction('pro_6_2')">签约产品</a>
          <Dropdown
            :transfer="true"
            trigger="hover"
            transfer-class-name="salesman-manage-dropdown-menu table-btn"
            @on-click="dropdownClick($event, row)"
            v-show="$units.pointAction('pro_6_3') || $units.pointAction('pro_6_4') || $units.pointAction('pro_6_5') || $units.pointAction('pro_6_6')"
          >
            <div class="more-btn">
              更多
              <Icon type="ios-arrow-down"></Icon>
            </div>
            <DropdownMenu slot="list">
              <DropdownItem name="add" v-if="$units.pointAction('pro_6_3') && row.covenantLevel == 1">新增补充协议</DropdownItem>
              <DropdownItem name="copy" v-if="$units.pointAction('pro_6_4')">复制协议</DropdownItem>
              <DropdownItem name="stop" v-if="$units.pointAction('pro_6_5') && row.status != '2' && row.status != '3'">终止 </DropdownItem>
              <DropdownItem name="del" v-if="$units.pointAction('pro_6_6')">删除</DropdownItem>
              <DropdownItem name="preview" v-if="row.fileJson && row.fileJson != '&quot;&quot;' && row.fileJson != '[]'">协议文档预览 </DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </template>
      </Table>
    </div>

    <div class="pageBox">
      <Page :total="total" :current="searchObj.pageNo" :page-size="searchObj.pageSize" show-total @on-change="pageChange" style="text-align: center" />
    </div>

    <stopAgreement ref="stop" :initList="initList"></stopAgreement>
    <previewModal ref="previewModal"></previewModal>
    <!-- 导入 -->
    <import-tool ref="importTool" @success="initList"></import-tool>
  </div>
</template>

<script>
import { pageTool, common } from '@/api/mixins';
import filters from '@/api/filter';
import stopAgreement from './stopAgreement';
import previewModal from './previewModal';
import importTool from '@/components/commons/importTool/index2';
import dayjs from 'dayjs';
export default {
  name: 'insuranceCompany',
  mixins: [pageTool, common],
  components: {
    importTool,
    stopAgreement,
    previewModal
  },
  filters,
  data() {
    return {
      levelCode: JSON.parse(localStorage.userInfo).levelCode,
      total: 0,
      searchObj: {
        pageNo: 1,
        pageSize: 10,
        covenantSource: 1, //协议种类（1、供应商代理协议2、渠道分销协议）
        covenantType: 2 //协议类型（1、保司协议2、通道协议）
      },
      insuranceCompanyList: [], //签约通道
      tableData: [],
      products: [], //签约产品
      productCompany: [], //产品所属保司
      signOrgTreeList: [], //签约机构
      columns: [
        {
          title: '协议名称',
          align: 'left',
          minWidth: 200,
          tree: true,
          slot: 'name',
          tooltip: true,
          className: 'name'
        },
        {
          title: '协议编号',
          minWidth: 200,
          tooltip: true,
          align: 'center',
          key: 'covenantNo'
        },
        {
          title: '协议类型',
          minWidth: 80,
          align: 'center',
          render(h, params) {
            const covenantLevel = params.row.covenantLevel;
            return <span>{covenantLevel == '1' ? '主协议' : '补充协议'}</span>;
          }
        },
        {
          title: '签约机构',
          minWidth: 150,
          align: 'center',
          key: 'signOrgName'
        },
        {
          title: '签约通道',
          minWidth: 100,
          align: 'center',
          key: 'insuranceSupplier'
        },
        {
          title: '状态',
          minWidth: 100,
          align: 'center',
          slot: 'status'
        },
        {
          title: '有效期',
          minWidth: 200,
          align: 'center',
          render(h, params) {
            const startTime = params.row.startTime;
            const result = params.row.endTime;
            return (
              <span>
                {filters.filterTime(startTime, 'YYYY-MM-DD') || '-'} 至 {filters.filterTime(result, 'YYYY-MM-DD') || '-'}
              </span>
            );
          }
        },
        {
          title: '签约产品数量',
          minWidth: 100,
          align: 'center',
          key: 'productNum'
        },
        {
          title: '终止日期',
          minWidth: 120,
          align: 'center',
          render(h, params) {
            const result = params.row.stopTime;
            const status = params.row.status;
            if (status === '3') {
              return <span>{filters.filterTime(result, 'YYYY-MM-DD') || '-'}</span>;
            } else {
              return <span>-</span>;
            }
          }
        },
        {
          title: '操作',
          width: 200,
          align: 'center',
          slot: 'action',
          fixed: 'right'
        }
      ]
    };
  },
  created() {
    if (
      !this.$units.pointAction('pro_6_1') &&
      !this.$units.pointAction('pro_6_2') &&
      !this.$units.pointAction('pro_6_3') &&
      !this.$units.pointAction('pro_6_4') &&
      !this.$units.pointAction('pro_6_5') &&
      !this.$units.pointAction('pro_6_6')
    ) {
      this.columns.splice(this.columns.length - 1, 1);
    }
    if (this.$route.query.date) {
      let startTime = dayjs(new Date()).format('YYYY-MM-DD');
      let endTime = dayjs(new Date().getTime() + 1000 * 60 * 60 * 24 * Number(this.$route.query.date)).format('YYYY-MM-DD');
      this.searchObj.date = [startTime, endTime];
      this.$nextTick(() => {
        this.searchMore = true;
      });
    }
    if (this.$route.query.status) {
      this.searchObj.status = this.$route.query.status;
      this.$nextTick(() => {
        this.searchMore = true;
      });
    }
    if (this.$route.query.covenantLevel) {
      this.searchObj.covenantLevel = this.$route.query.covenantLevel;
      this.$nextTick(() => {
        this.searchMore = true;
      });
    }
  },
  activated() {
    this.initList();
    this.queryCompanyList();
    this.queryInsuranceCompanyList();
    this.queryContractedProducts();
    this.querySignOrgTree();
  },
  methods: {
    // 处理请求参数
    setRequestParam() {
      let obj = JSON.parse(JSON.stringify(this.searchObj));
      let { ...params } = obj;
      if (obj.date && obj.date.length > 0) {
        params.endCovenantStartTime = obj.date[0];
        params.endCovenantEndTime = obj.date[1];
      }
      return params;
    },
    // 打开批量导入弹窗
    importData() {
      if(!this.$units.pointAction('pro_6_7')){
        this.$notice.error('无权操作，请联系您的上级');
        return
      }
      this.$refs.importTool.open({
        params: { type: 2 },
        template: '/buz/covenant/downloadTemplate',
        // templateName: '保司协议导入模板.xls',
        uploadParams: { type: 2 },
        uploadUrl: '/buz/covenant/import',
        uploadCallback: res => {
          if (res.data.errorCount) {
            this.$units.downloadFile(
              '/buz/covenant/downloadTemplate',
              {
                type: 2,
                batchNo: res.data.batchNo
              },
              'GET'
            );
            this.$notice.error(`系统已成功导入${res.data.successCount}条数据，存在${res.data.errorCount}条数据未导入`);
          } else {
            this.$refs.importTool.visible = false;
            this.$notice.success(`系统已成功导入${res.data.successCount}条数据`);
          }
          this.search();
        }
      });
    },

    // 查询所属保司
    queryCompanyList() {
      this.$http({
        url: '/buz/insuranceCompany/read/list',
        type: 'POST',
        data: {
          companyType: '1'
        }
      }).then(res => {
        this.productCompany = res.data;
      });
    },

    // 查询签约通道
    queryInsuranceCompanyList() {
      this.$http({
        url: '/buz/insuranceChannel/read/list',
        type: 'POST',
        data: {}
      }).then(res => {
        this.insuranceCompanyList = res.data;
      });
    },

    // 查询签约产品
    queryContractedProducts() {
      this.$http({
        url: '/buz/productBase/read/array',
        type: 'POST',
        data: {
          productName: ''
        }
      }).then(res => {
        this.products = res.data;
      });
    },

    // 查询签约机构
    querySignOrgTree() {
      this.$http({
        url: `/buz/organizationBase/read/list`,
        type: 'POST',
        data: {
          pageNo: 1,
          pageSize: 9999,
          orgTypes: ['1', '2'],
          status: 1
        }
      }).then(res => {
        this.signOrgTreeList = res.data;
      });
    },

    // 查询
    initList() {
      this.$root.$children[0].isShowLoading = true;
      this.$http({
        url: '/buz/covenant/read/list',
        type: 'POST',
        data: this.setRequestParam(),
        apiPermissionCode: 'pro_6_0'
      }).then(res => {
        this.total = res.total;
        this.tableData = this.handleTableTree(res.data);
        this.$root.$children[0].isShowLoading = false;
      });
    },

    // 处理树形数据
    handleTableTree(arr) {
      return arr.map(item => ({
        ...item,
        children: item.sonCovenants ? this.handleTableTree(item.sonCovenants) : []
        // _showChildren: item.sonCovenants && item.sonCovenants.length ? true : false 默认收起
      }));
    },

    // 重置
    reset() {
      this.searchObj = {
        pageNo: 1,
        pageSize: 10,
        covenantSource: 1,
        covenantType: 2
      };
      this.initList();
    },

    // 搜索
    search() {
      this.searchObj.pageNo = 1;
      this.initList();
    },

    // 更多操作
    dropdownClick(name, row) {
      if (name == 'add') {
        this.addSupplementAgreement(row);
      } else if (name == 'copy') {
        this.copyAgreement(row);
      } else if (name == 'stop') {
        this.$refs.stop.open(row);
      } else if (name == 'del') {
        this.submitDelete(row);
      } else if (name == 'preview') {
        this.$refs.previewModal.open(JSON.parse(row.fileJson));
      }
    },

    // 新增协议
    addAgreement() {
      if(!this.$units.pointAction('pro_6_1')) {
        this.$notice.error('无权操作，请联系您的上级');
        return
      }
      this.openPageTabTags('/offline/agreementManage/supplierAgreement/channelForm', {
        covenantLevel: 1,
        addParentFlag: 0
      });
    },

    // 编辑
    edit(row) {
      this.openPageTabTags('/offline/agreementManage/supplierAgreement/channelFormEdit', {
        editFlag: 1,
        rowId: row.id
      });
    },

    // 新增补充协议
    addSupplementAgreement(row) {
      this.openPageTabTags('/offline/agreementManage/supplierAgreement/addSupplementChannelForm', {
        covenantLevel: 2,
        addParentFlag: 1,
        rowId: row.id,
        parentCovenantName: row.name,
        parentCovenantNo: row.covenantNo
      });
    },

    // 复制协议
    copyAgreement(row) {
      this.openPageTabTags('/offline/agreementManage/supplierAgreement/channelFormCopy', {
        copyFlag: 1,
        rowId: row.id
      });
    },

    // 删除
    async submitDelete(item) {
      let checkDel = await this.$http({
        url: `/buz/covenant/checkDel?id=${item.id}`,
        type: 'GET'
      });
      this.$notice.inquiry(checkDel.data ? '确认删除操作？' : '该协议的签约产品已产生关联保单，请确认是否删除？').then(async () => {
        this.$http({
          url: `/buz/covenant/del?id=${item.id}`,
          type: 'GET',
          apiPermissionCode: 'pro_6_6'
        }).then(res => {
          this.$notice.success('删除成功');
          this.initList();
        });
      });
    },

    // 签约产品
    signProduct(row) {
      this.$router.push({
        path: '/offline/agreementManage/supplierAgreement/channelFormEdit',
        query: {
          rowId: row.id,
          editFlag: 1,
          is_signProduct: 1,
          disabled: row.status == '2' || row.status == '3' ? 1 : 0
        }
      });
    },

    // 分页
    pageChange(pageNo) {
      this.searchObj.pageNo = pageNo;
      this.initList();
    }
  }
};
</script>

<style lang="scss" scoped>
.fileName {
  cursor: pointer;
  color: #236dff;
}
/deep/.ivu-select-input {
  height: 28px;
}

.more-btn {
  width: 60px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 10px;
  background: #f4f7ff;
  border: 2px;
  color: #236dff;
  font-size: 13px;
}

/deep/.ivu-table-tbody {
  .name {
    .ivu-table-cell {
      display: flex;
      width: calc(100% - 20px);
      overflow: unset;
    }
  }
}

.pageBox {
  margin-top: 20px;
}
</style>
